module.exports = __webpack_public_path__ + "static/media/whatsapp.c01333ef.png";